import { useEffect } from 'react';

/**
 * The browser's own "Leave site?" while `active` (spec 121 FR-010; spec 123
 * FR-015).
 *
 * Shared by the task draft dock and the connection form: each decides when
 * leaving would cost something — a staged or uploading file, a half-typed
 * connection — and arms this for exactly that long.
 */
export function useBeforeUnloadGuard(active: boolean) {
  useEffect(() => {
    if (!active) return;
    const ask = (event: BeforeUnloadEvent) => {
      event.preventDefault();
    };
    window.addEventListener('beforeunload', ask);
    return () => {
      window.removeEventListener('beforeunload', ask);
    };
  }, [active]);
}
